module.exports = __webpack_public_path__ + "img/active-c.6127757f.png";